import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';
import CrudApiClient from './crudapiclient';

class SkuAPIClient extends CrudApiClient {
  constructor(target?: string) {
    let url = GATEWAY_API_URL + '/sku';
    if (target && target !== '') url += '/' + target;
    super(url);
  }

  async search(query: any, page: number, size: number, meta: MetaQuery | undefined): Promise<any> {
    try {
      if (!query.filters || query.filters.length == 0) {
        return [];
      }
      return await super.search(query, page, size, meta);
    } catch (error) {
      console.error(`Error searching entities with Query:`, query, error);
      throw error;
    }
  }

  async findStyleNumbersByProductId(productId: number, signal?: AbortSignal): Promise<string[]> {
    const pageSize = 100;
    const styles = new Set<string>();
    const query = {
      filters: [{ field: 'productId', value: String(productId), filterType: 'EQ' }],
      orderBy: 'id',
      orderDirection: 'ASC',
    };
    for (let page = 1; ; page += 1) {
      const skus = await this.search(query, page, pageSize, { signal });
      if (!Array.isArray(skus)) throw new Error('Could not load product style membership.');
      for (const sku of skus) {
        if (typeof sku.lkStyleNumber !== 'string' || !sku.lkStyleNumber.trim()) {
          throw new Error('A SKU is missing its LK style number. Contact the tech team.');
        }
        styles.add(sku.lkStyleNumber.trim().toUpperCase());
      }
      if (skus.length < pageSize) return [...styles].sort();
    }
  }

  async deleteSkusSafely(
    _sorters: unknown,
    _filters: unknown,
    payload: { skus: Array<string>; reason: string },
    _query: unknown,
    _headers: unknown,
    _meta: MetaQuery | undefined,
  ): Promise<unknown> {
    void _query;
    void _headers;
    void _meta;
    const response = await axiosInstance.post(`${this.baseURL}/delete-safely`, payload);
    return response.data?.data;
  }
}

export default SkuAPIClient;
